import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sum' })
export class Sum implements PipeTransform {
  transform(jobno: any): any {
    let a: number = 0;
    if (!jobno) {
    } else {
      jobno.Prodlist.forEach((x: any) => {
        a = Number(a) + Number(x.AMOUNT);
      });
    }
    return a;
  }
}
